import { fetchEntities } from 'actions/entities';
import ConsultationPriceBatchForm from 'components/consultation_prices/ConsultationPriceBatchForm';
import React from 'react'

import { connect } from 'react-redux'
import { Message } from "semantic-ui-react";
import ConsultationTypesListContainer from "../consultation_types/ConsultationTypesListContainer";

class ConsultationPrices extends React.Component {
  componentDidMount() {
    this.props.fetchEntities()
  }

  render () {
    const readOnly = !this.props.editable
    return (
      <div>
        {readOnly ? <Message>{I18n.t('components.locations_list.read_only')}</Message> : null}
        <ConsultationTypesListContainer readonly={readOnly}/>
        <ConsultationPriceBatchForm readonly={readOnly}/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.meta.consultationPrice.loading,
    error: state.meta.consultationPrice.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultationPrices'))
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ConsultationPrices)
